import { createSlice } from "@reduxjs/toolkit";

const KEY = "noleyo:nickname";

const initialState = {
  nickname: localStorage.getItem(KEY) || "",
};

const nicknameSlice = createSlice({
  name: "nickname",
  initialState,
  reducers: {
    setNickname(state, action) {
      state.nickname = action.payload;
      localStorage.setItem(KEY, action.payload);
    },
    clearNickname(state) {
      state.nickname = "";
      localStorage.removeItem(KEY);
    },
  },
});

export const { setNickname, clearNickname } = nicknameSlice.actions;
export default nicknameSlice.reducer;
